import { render, staticRenderFns } from "./FlatAdsRent.vue?vue&type=template&id=b214e2dc"
import script from "./FlatAdsRent.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlatAdsRent.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports